import React from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import { FaStar } from "react-icons/fa";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop-page">
      <div className="shop-container">
        <nav className="breadcrumb">
          <Link onClick={toTop} to="/">
            Home
          </Link>
          <span className="separator">|</span>
          <Link onClick={toTop} to="/shop">
            All Hardware
          </Link>
          <span className="separator">|</span>
          <span className="current">New In</span>
        </nav>

        <header className="shop-header">
          <div className="banner-content">
            <h1>New In</h1>
            <p className="description">
              Say hello to our new-in-stock designs. Here you'll find our latest
              meticulously-made products, suited to upgrade your home interior
              touchpoints; kitchens, bedrooms, bathrooms, utility spaces or
              furniture upcycles...
            </p>
            <div className="rating-summary">
              <div className="stars">
                {[...Array(5)].map((_, i) => (
                  <FaStar key={i} />
                ))}
              </div>
              <span className="reviews-text">4949 reviews</span>
              <span className="yotpo-logo">yotpo.</span>
            </div>
          </div>
        </header>

        <main className="product-grid">
          {productData.map((product) => (
            <div key={product.id} className="product-item">
              <Link onClick={toTop} to={`/shopDetails/${product.id}`}>
                <div className="product-image-container">
                  {product.id === 19 || product.id === 20 ? (
                    <span className="product-badge new">NEW</span>
                  ) : null}
                  {product.id === 21 ? (
                    <span className="product-badge new-finish">NEW FINISH</span>
                  ) : null}
                  <img src={product.image} alt={product.name} />
                </div>
                <div className="product-details">
                  <h2 className="product-name">{product.name}</h2>
                  <p className="product-price">${product.price}</p>
                </div>
              </Link>
            </div>
          ))}
        </main>
      </div>
    </div>
  );
}

export default Shop;
